import {LoanPaidInFull as LoanPaidInFullLetter} from 'Agent/Policies/api/apiTypes';
import React from 'react';
import CardField from 'Shared/components/CardField';
import {toFormattedDateAsUTC} from 'Shared/utilities/DateFormatter';

type LoanPaidInFullProps = {
  loadPaidInFullLetter: LoanPaidInFullLetter;
};

const LoanPaidInFull = (props: LoanPaidInFullProps) => {
  return (
    <>
      <CardField name="Agent Number" value={props.loadPaidInFullLetter.agentNumber} />
      <CardField name="Date" value={toFormattedDateAsUTC(props.loadPaidInFullLetter.date)} />
      <CardField name="Insured Name" value={props.loadPaidInFullLetter.insuredName} />
      <CardField name="Owner Name" value={props.loadPaidInFullLetter.ownerName} />
      <CardField name="Owner Address" value={props.loadPaidInFullLetter.ownerAddress!.fullAddress} />
      <CardField name="Policy Number" value={props.loadPaidInFullLetter.policyNumber} />
    </>
  );
};

export default LoanPaidInFull;
